import axios from "axios";
import { AuditActionOption, AuditLogRequest, AuditLogRow, Nullable } from "../interfaces";
import api from "./api";

const baseURLAPI = process.env.REACT_APP_API_HOST;
const AUDIT_API_VERSION = "v1";

const toQuery = (request: AuditLogRequest) => {
  const params = new URLSearchParams();
  if (request.dateStart) params.append("dateStart", request.dateStart);
  if (request.dateEnd) params.append("dateEnd", request.dateEnd);
  if (request.entityID !== undefined && request.entityID !== null) {
    params.append("entityId", String(request.entityID));
  }
  const user = request.user?.trim();
  if (user) params.append("user", user);
  if (request.buCode) params.append("buCode", request.buCode);
  if (request.auditActions && request.auditActions.length > 0) {
    request.auditActions.forEach((id) => params.append("auditActions", String(id)));
  }
  return params.toString();
};

export const getAuditLog = async (
  request: AuditLogRequest
): Promise<Nullable<AuditLogRow[]>> => {
  const query = toQuery(request);
  const uri = `${baseURLAPI}/${AUDIT_API_VERSION}/Audit/log?${query}`;

  try {
    const response = await api.get(uri);

    if (response.status === 200) {
      return response.data as AuditLogRow[];
    }
  } catch (error) {
    console.error("Error fetching audit log", error);
  }

  return null;
};

export const searchAuditActions = async (
  actionId?: number,
  shortName?: string,
  options?: { signal?: AbortSignal }
): Promise<Nullable<AuditActionOption[]>> => {
  const params = new URLSearchParams();
  if (typeof actionId === "number") params.append("actionId", String(actionId));
  const term = shortName?.trim();
  if (term) params.append("shortName", term);
  const qs = params.toString();
  const uri = `${baseURLAPI}/${AUDIT_API_VERSION}/Audit/actions/search${qs ? `?${qs}` : ""}`;

  try {
    const response = await api.get(uri, { signal: options?.signal });
    if (response.status === 200) {
      return response.data as AuditActionOption[];
    }
  } catch (error) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching audit actions", error);
  }
  return null;
};
